import React, { useState } from 'react';

const IconInstagram = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
);

const IconFacebook = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M15 3h-2a5 5 0 0 0-5 5v3H6v4h2v6h4v-6h3l1-4h-4V8a1 1 0 0 1 1-1h3z" />
  </svg>
);

const IconYoutube = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="6" width="20" height="12" rx="3" />
    <path d="M10 9.5l5 2.5-5 2.5z" fill="currentColor" stroke="none" />
  </svg>
);

const IconLinkedIn = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4V8h4v2a4.5 4.5 0 0 1 2-2z" />
    <rect x="2" y="8" width="4" height="13" />
    <circle cx="4" cy="4" r="2" />
  </svg>
);

export default function Navbar() {
  const [activeNav, setActiveNav] = useState('home');
  const [isNavExpanded, setIsNavExpanded] = useState(false);
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });

  const menuItems = [
    { id: 'home', label: 'HOME' },
    { id: 'about', label: 'ABOUT' },
    { id: 'journey', label: 'JOURNEY' },
    { id: 'achievements', label: 'ACHIEVEMENTS' },
    { id: 'gallery', label: 'GALLERY' },
    { id: 'contact', label: 'CONTACT' },
  ];

  const socialIcons = [
    { Icon: IconInstagram, color: '#ff9933', label: 'Instagram', url: 'https://instagram.com/yourprofile' },
    { Icon: IconFacebook, color: '#000080', label: 'Facebook', url: 'https://facebook.com/yourprofile' },
    { Icon: IconYoutube, color: '#138808', label: 'YouTube', url: 'https://youtube.com/@yourchannel' },
    { Icon: IconLinkedIn, color: '#0a66c2', label: 'LinkedIn', url: 'https://www.linkedin.com/in/parag-patil-senior-olympian-0a77a5188/' },
  ];

  const handleNavClick = (id) => {
    setActiveNav(id);
    setIsNavExpanded(false);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(`Enquiry from ${formData.name}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\nMessage:\n${formData.message}`
    );
    window.location.href = `mailto:your.email@example.com?subject=${subject}&body=${body}`;
    setFormData({ name: '', email: '', phone: '', message: '' });
    setShowEnquiry(false);
  };

  return (
    <>
      <nav style={styles.navbar} className="navbar navbar-expand-xl py-2">
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800;900&display=swap');

          html, body {
            max-width: 100% !important;
            overflow-x: hidden !important;
            scrollbar-gutter: stable;
          }

          body {
            padding-top: 80px;
          }

          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(8px); }
            to { opacity: 1; transform: translateY(0); }
          }

          .brand-wrap {
            display: inline-flex !important;
            flex-direction: column !important;
            line-height: 1 !important;
            text-decoration: none !important;
            padding: 4px 0 !important;
            cursor: pointer !important;
            width: fit-content !important;
          }

          .big-p {
            font-size: 1.3em;
            font-weight: 900;
          }

          .brand-text {
            font-size: 20px;
            font-weight: 900;
            letter-spacing: 1.5px;
            text-transform: uppercase;
            font-family: 'Poppins', sans-serif;
            display: flex;
            align-items: baseline;
          }

          .brand-subtitle {
            font-size: 9px;
            font-weight: 900;
            letter-spacing: 2px;
            color: #475569;
            text-transform: uppercase;
            margin-top: 3px;
            font-family: 'Poppins', sans-serif;
          }

          .brand-accent {
            display: block !important;
            width: 100% !important;
            height: 3px !important;
            margin-top: 3px !important;
            border-radius: 999px !important;
            background: linear-gradient(90deg, #ff9933 0%, #d0d0ec 50%, #138808 100%) !important;
            transform: scaleX(0.35) !important;
            transform-origin: left !important;
            transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1) !important;
          }

          .brand-wrap:hover .brand-accent {
            transform: scaleX(1) !important;
          }

          .custom-nav-link {
            color: #334155;
            font-size: 12px;
            letter-spacing: 0.8px;
            padding: 8px 14px;
            border-radius: 999px;
            text-decoration: none;
            transition: all 0.25s ease;
            font-weight: 700;
            font-family: 'Poppins', sans-serif;
            display: inline-block;
          }

          .custom-nav-link:hover {
            color: #ff9933 !important;
            background-color: rgba(255, 153, 51, 0.12);
            transform: translateY(-2px);
          }

          .custom-nav-link.active-link {
            color: #000080 !important;
            border: 1px solid #cbd5e1;
            background: #f1f5f9;
          }

          .social-circle {
            width: 36px;
            height: 36px;
            border-radius: 50%;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            text-decoration: none;
            border: none !important;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
            transition: all 0.25s ease;
          }

          .social-circle svg {
            display: block;
            margin: 0 auto;
            transition: color 0.25s ease;
          }

          .social-circle:hover {
            transform: translateY(-3px) scale(1.08);
            background-color: var(--brand-color) !important;
            color: #ffffff !important;
            box-shadow: 0 6px 16px rgba(0, 0, 0, 0.18);
          }

          .premium-btn {
            box-shadow: 0 4px 12px rgba(255, 153, 51, 0.30) !important;
            font-family: 'Poppins', sans-serif;
            margin-left: 8px;
          }

          .premium-btn:hover {
            background-color: #e68a00 !important;
            transform: translateY(-2px);
            box-shadow: 0 6px 20px rgba(255, 153, 51, 0.45) !important;
          }

          .modal-backdrop-custom {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(15, 23, 42, 0.55);
            z-index: 1050;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 16px;
            backdrop-filter: blur(6px);
            box-sizing: border-box;
          }

          .modal-box-custom {
            width: 100%;
            max-width: 460px;
            background: #fff;
            border-radius: 20px;
            padding: 0;
            box-shadow: 0 24px 60px rgba(15, 23, 42, 0.28);
            animation: fadeUp 0.28s cubic-bezier(0.4, 0, 0.2, 1);
            font-family: 'Poppins', sans-serif;
            overflow: hidden;
          }

          .modal-header-custom {
            background: linear-gradient(120deg, #000080 0%, #0a1f6b 100%);
            padding: 22px 24px;
            position: relative;
          }

          .modal-header-custom::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 3px;
            background: linear-gradient(90deg, #ff9933 0%, #d0d0ec 50%, #138808 100%);
          }

          .modal-title-custom {
            color: #ffffff;
            font-weight: 800;
            font-size: 18px;
            letter-spacing: 0.3px;
            margin: 0;
          }

          .modal-subtitle-custom {
            color: rgba(255, 255, 255, 0.7);
            font-size: 12px;
            font-weight: 500;
            margin-top: 3px;
          }

          .modal-close-custom {
            position: absolute;
            top: 16px;
            right: 16px;
            width: 30px;
            height: 30px;
            border-radius: 50%;
            border: none;
            background: rgba(255, 255, 255, 0.12);
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s ease;
            font-size: 16px;
            line-height: 1;
          }

          .modal-close-custom:hover {
            background: #ff9933;
            transform: rotate(90deg);
          }

          .modal-body-custom {
            padding: 22px 24px 24px;
          }

          .form-field-group {
            margin-bottom: 16px;
          }

          .form-field-label {
            display: block;
            font-size: 11px;
            font-weight: 700;
            letter-spacing: 0.6px;
            text-transform: uppercase;
            color: #475569;
            margin-bottom: 6px;
          }

          .form-field-input {
            width: 100%;
            border: 1.5px solid #e2e8f0;
            border-radius: 10px;
            padding: 11px 14px;
            font-size: 14px;
            font-family: 'Poppins', sans-serif;
            color: #0f172a;
            background: #f8fafc;
            transition: all 0.2s ease;
            outline: none;
            box-sizing: border-box;
          }

          .form-field-input:focus {
            border-color: #ff9933;
            background: #ffffff;
            box-shadow: 0 0 0 3px rgba(255, 153, 51, 0.14);
          }

          textarea.form-field-input {
            resize: vertical;
            min-height: 90px;
          }

          .submit-btn-custom {
            width: 100%;
            border: none;
            border-radius: 10px;
            padding: 12px;
            font-weight: 800;
            font-size: 14px;
            letter-spacing: 0.4px;
            color: #ffffff;
            background: #ff9933;
            box-shadow: 0 4px 12px rgba(255, 153, 51, 0.30);
            transition: all 0.25s ease;
          }

          .submit-btn-custom:hover {
            background: #e68a00;
            transform: translateY(-2px);
            box-shadow: 0 6px 18px rgba(255, 153, 51, 0.42);
          }

          @media (max-width: 1199.98px) {
            .navbar-collapse {
              background: rgba(255,255,255,0.98);
              backdrop-filter: blur(10px);
              padding: 1rem;
              border-radius: 14px;
              box-shadow: 0 10px 25px rgba(0,0,0,0.10);
              margin-top: 0.75rem;
              max-height: calc(100vh - 100px);
              overflow-y: auto;
            }
            .nav-item {
              width: 100%;
              text-align: left;
            }
            .custom-nav-link {
              padding: 12px 4px !important;
              display: block;
            }
            .premium-btn {
              margin-left: 0;
              width: 100%;
            }
          }

          @media (max-width: 767.98px) {
            .brand-text {
              font-size: 17px;
            }
            .brand-subtitle {
              font-size: 8px;
            }
            .social-circle {
              width: 34px;
              height: 34px;
            }
          }

          @media (max-width: 575.98px) {
            .brand-text {
              font-size: 15px;
              letter-spacing: 1px;
            }
            .brand-subtitle {
              font-size: 7px;
              letter-spacing: 1.5px;
            }
            .navbar-toggler {
              padding: 4px 8px;
            }
            .modal-box-custom {
              max-width: 100%;
              border-radius: 16px;
            }
            .modal-header-custom {
              padding: 18px 18px;
            }
            .modal-body-custom {
              padding: 18px 18px 20px;
            }
            .modal-title-custom {
              font-size: 16px;
            }
          }
        `}</style>

        <div className="container-fluid px-3 px-md-4 px-lg-5">
          <a className="navbar-brand brand-wrap" href="#home">
            <div className="brand-text">
              <span style={{ color: '#ff9933' }}>
                <span className="big-p">P</span>ARAG
              </span>
              &nbsp;
              <span style={{ color: '#138808' }}>
                <span className="big-p">P</span>ATIL
              </span>
            </div>

            <div className="brand-subtitle">
              PROFESSIONAL ATHLETE
            </div>

            <span className="brand-accent"></span>
          </a>

          <button
            className="navbar-toggler border-0 shadow-none"
            type="button"
            aria-controls="navbarNav"
            aria-expanded={isNavExpanded}
            aria-label="Toggle navigation"
            onClick={() => setIsNavExpanded(!isNavExpanded)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse align-items-xl-center ${isNavExpanded ? 'show' : ''}`} id="navbarNav">
            <ul className="navbar-nav gap-lg-1 align-items-center mx-xl-auto">
              {menuItems.map((item) => (
                <li className="nav-item" key={item.id}>
                  <a
                    className={`custom-nav-link ${activeNav === item.id ? 'active-link' : ''}`}
                    href={`#${item.id}`}
                    onClick={() => handleNavClick(item.id)}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>

            <div className="d-flex flex-column flex-xl-row align-items-center gap-3 gap-xl-4 mt-3 mt-xl-0">
              <div className="d-flex gap-3 justify-content-center align-items-center">
                {socialIcons.map(({ Icon, color, label, url }, idx) => (
                  <a
                    key={idx}
                    href={url}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={label}
                    title={label}
                    style={{
                      color: color,
                      backgroundColor: `${color}1A`,
                      '--brand-color': color,
                    }}
                    className="social-circle"
                  >
                    <Icon />
                  </a>
                ))}
              </div>

              <button className="btn premium-btn ms-xl-2" style={styles.enquiryButton} onClick={() => setShowEnquiry(true)}>
                Enquiry
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Enquiry Form Modal */}
      {showEnquiry && (
        <div className="modal-backdrop-custom">
          <div className="modal-box-custom">
            <div className="modal-header-custom">
              <h5 className="modal-title-custom">Get in Touch</h5>
              <div className="modal-subtitle-custom">We'll get back to you as soon as possible</div>
              <button
                className="modal-close-custom"
                onClick={() => setShowEnquiry(false)}
                aria-label="Close"
                type="button"
              >
                ✕
              </button>
            </div>

            <div className="modal-body-custom">
              <form onSubmit={handleSubmit}>
                <div className="form-field-group">
                  <label className="form-field-label" htmlFor="enquiry-name">Full Name</label>
                  <input
                    className="form-field-input"
                    id="enquiry-name"
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    required
                  />
                </div>

                <div className="form-field-group">
                  <label className="form-field-label" htmlFor="enquiry-email">Email Address</label>
                  <input
                    className="form-field-input"
                    id="enquiry-email"
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="you@example.com"
                    required
                  />
                </div>

                <div className="form-field-group">
                  <label className="form-field-label" htmlFor="enquiry-phone">Phone Number</label>
                  <input
                    className="form-field-input"
                    id="enquiry-phone"
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="+91 98765 43210"
                    required
                  />
                </div>

                <div className="form-field-group">
                  <label className="form-field-label" htmlFor="enquiry-message">Message</label>
                  <textarea
                    className="form-field-input"
                    id="enquiry-message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Tell us what you'd like to know..."
                    required
                  />
                </div>

                <button type="submit" className="submit-btn-custom">
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
                    Send Enquiry
                  </span>
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

const styles = {
  navbar: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    maxWidth: '100%',
    zIndex: 1000,
    background: '#ffffff',
    boxShadow: '0 2px 18px rgba(0,0,0,0.08)',
    borderBottom: '1px solid #e5e7eb',
  },
  enquiryButton: {
    backgroundColor: '#ff9933',
    color: '#ffffff',
    border: 'none',
    borderRadius: '999px',
    padding: '8px 22px',
    fontWeight: 800,
    transition: 'all 0.3s ease',
    whiteSpace: 'nowrap',
  },
};
